var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"checkbox","true-value":"true","false-value":"false"},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.updateValue($event.target.checked)}}})}
var staticRenderFns = []

export { render, staticRenderFns }